<template>
  <svg
    class="c-documents-icon"
    width="24"
    height="36"
    viewBox="0 0 24 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.375 3.75A.375.375 0 0 0 15 3.375H4.5A4.125 4.125 0 0 0 .375 7.5v21A4.125 4.125 0 0 0 4.5 32.625h15a4.125 4.125 0 0 0 4.125-4.125V13.72a.375.375 0 0 0-.375-.375H16.5a1.125 1.125 0 0 1-1.125-1.125V3.75zM16.5 18.375a1.125 1.125 0 1 1 0 2.25h-9a1.125 1.125 0 1 1 0-2.25h9zm0 6a1.125 1.125 0 1 1 0 2.25h-9a1.125 1.125 0 1 1 0-2.25h9z"
      :fill="color"
    />
    <path
      d="M17.625 4.236c0-.276.29-.451.504-.279.182.147.343.318.484.513l4.52 6.295c.102.144-.009.33-.186.33H18a.375.375 0 0 1-.375-.375V4.236z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts" setup>
withDefaults(defineProps<{ color?: string }>(), { color: '#5b6c50' });
</script>
